import {
  getLocalToken,
  DMSAccessTokenKey,
  DMSRefreshTokenKey
} from '@/apps/auth/utils'
/**
 * State function
 */
export default function() {
  return {
    accessToken: getLocalToken(DMSAccessTokenKey),
    refreshToken: getLocalToken(DMSRefreshTokenKey),
    refreshingCall: null
  }
}



// WEBPACK FOOTER //
// ./src/apps/auth/store/state.js